module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'the-banner': true, 'auto-pay': _vm.$route.query.pay
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('Timeline', {
    attrs: {
      "show-time-line": _vm.cart.accomodations.filter(function(a) {
        return a.confirmed;
      }).length,
      "steps": _vm.timelineSteps
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bg-color-faded"
  }, [_c('div', {
    staticClass: "container"
  }, [(!_vm.$store.state.cart.addToOrder || !_vm.$store.state.cart.addToOrder.accomodationRow) ? _c('div', {
    staticClass: "optional-booking min-tablet"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('general.make-it-easier')))]), _vm._v(" "), _c('CompletedBookings', {
    staticStyle: {
      "margin-top": "0"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('general.your-cart')))]), _vm._v(" "), _c('Cart', {
    attrs: {
      "show-from-start": true
    }
  }), _vm._v(" "), (_vm.$store.state.cart.addToOrder && _vm.$store.state.cart.addToOrder.number) ? _c('div', {
    staticClass: "appending-info"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('general.when-you-click', {
    number: ''
  })) + " "), _c('router-link', {
    attrs: {
      "to": {
        name: 'my booking',
        params: {
          bookingNumber: _vm.$store.state.cart.addToOrder.numeric
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.$store.state.cart.addToOrder.number))]), (_vm.$store.state.cart.addToOrder.dateStart) ? _c('span', [_vm._v(" (" + _vm._s(_vm._f("dateRange")([_vm.$store.state.cart.addToOrder.dateStart, _vm.$store.state.cart.addToOrder.dateEnd])) + ")")]) : _vm._e(), _vm._v(".")], 1), _vm._v(" "), (_vm.$store.state.cart.addToOrder.accomodationRow) ? _c('p', [_vm._v("Bokningen kommer att kopplas till boendet "), _c('b', [_vm._v(_vm._s(_vm.$store.state.cart.addToOrder.accomodationName))]), _vm._v(" (" + _vm._s(_vm._f("dateRange")([_vm.$store.state.cart.addToOrder.accomodationDateArrival, _vm.$store.state.cart.addToOrder.accomodationDateDeparture])) + ").")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('general.new-order', {
    clickhere: ''
  }))), _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        return _vm.removeOrderLink()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.clickhere')))]), _vm._v(".")])]) : _vm._e(), _vm._v(" "), (!_vm.$store.state.cart.addToOrder || !_vm.$store.state.cart.addToOrder.accomodationRow) ? _c('div', {
    staticClass: "optional-booking max-mobile",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('general.make-it-easier')))]), _vm._v(" "), _c('CompletedBookings', {
    staticStyle: {
      "margin-top": "0"
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "bg-color-faded related-orders"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.openRelatedOrders.length) ? _c('div', {
    staticClass: "appending-info",
    staticStyle: {
      "margin-top": "0"
    }
  }, [_c('p', [_vm._v("Det finns en annan tilläggsbokning som inte har betalats. Avbryt den innan du går vidare.")]), _vm._v(" "), _c('table', {
    staticClass: "order-table"
  }, _vm._l((_vm.openRelatedOrders), function(order, index) {
    return _c('tr', [_c('td', [_vm._v("\n              " + _vm._s(_vm._f("date")(order.created_at, 'short-with-time')) + "\n            ")]), _vm._v(" "), _c('td', [_vm._v("\n              " + _vm._s(_vm._f("currency")(order.sum)) + "\n            ")]), _vm._v(" "), _c('td', [_c('a', {
      class: 'button small' + (order.vue_working_status ? ' disabled' : ''),
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.cancelOrder(index)
        }
      }
    }, [_vm._v("Avbryt")])]), _vm._v(" "), _c('td', [(order.vue_working_status) ? _c('span', [_vm._v("Avbryter...")]) : _vm._e()])])
  }), 0)]) : _vm._e()])]), _vm._v(" "), (_vm.showTryPayment) ? _c('div', {
    staticClass: "bg-color-faded"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "bottom-buttons-wrapper"
  }, [_c('div', [_c('CheckoutCodeModal')], 1), _vm._v(" "), _c('div', {
    class: {
      'disabled': !_vm.enableTryPayment
    },
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('p', [_vm._v(" ")]), _vm._v(" "), _c('button', {
    on: {
      "click": function($event) {
        return _vm.tryPayment()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.cta.pay')) + " "), _c('icon', {
    attrs: {
      "name": "arrow-white",
      "scale": 1.5
    }
  })], 1)])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c8aa54fe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/ShoppingCartPage.vue
// module id = 1004
// module chunks = 0